import { BaseEdge, EdgeLabelRenderer, EdgeProps, getStraightPath } from "@xyflow/react";
import { memo } from "react";

export default memo(({ id, sourceX, sourceY, targetX, targetY, label }: EdgeProps) => {
    const [ edgePath, labelX, labelY ] = getStraightPath({
        sourceX,
        sourceY,
        targetX,
        targetY,
    });

    return (
        <>
            <BaseEdge id={id} path={edgePath}/>
            <EdgeLabelRenderer>
                <div style={{
                    position: 'absolute',
                    transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
                    pointerEvents: 'all',
                }} 
                className="bg-white py-1"
                >
                    <p className="text-warning text-[12px] font-semibold">{label}</p>
                </div>
            </EdgeLabelRenderer>
        </>
    )
})